export default "//yastatic.net/s3/distribution/pythia/frontend/_/d35fdc1b4ef6acf2ace15cfecaab31ba.svg";